import { NavLink } from 'react-router-dom';
import logo_cms from '../../assets/images/logo-dark2x.png';
import logo_cms_small from '../../assets/images/logo-dark-small2x.png';
import { MenuRender, MenuRenderCollapsed } from './Menu';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

type ISideBarProps = {
	isShowSideBarMobile: boolean | false;
	isShowSideBar: boolean | false;
	showSideBar: () => void;
	setShowSidebarMobile: () => void;
};

const Sidebar = (props: ISideBarProps) => {
	const { isShowSideBar, isShowSideBarMobile, showSideBar, setShowSidebarMobile } = props;
    
	return (
		<>
             {/* Mobile overlay */}
            {isShowSideBarMobile && (
                <div 
                    className="fixed inset-0 z-40 bg-black/80 lg:hidden" 
                    onClick={setShowSidebarMobile}
                />
            )}

			<aside
				className={cn(
                    "fixed inset-y-0 left-0 z-50 flex h-full w-72 flex-col border-r border-border/70 bg-card/85 backdrop-blur-xl transition-all duration-300 ease-in-out lg:static lg:translate-x-0",
                    isShowSideBarMobile ? "translate-x-0" : "-translate-x-full",
                    isShowSideBar ? "lg:w-20" : "lg:w-72"
                )}
			>
                <div className="flex h-16 shrink-0 items-center justify-between border-b border-border/70 px-4 lg:px-6">
					<NavLink to='/' className="flex items-center gap-2 font-semibold">
						<img 
                            className={cn("h-8 object-contain transition-all", isShowSideBar ? "hidden" : "block")} 
                            src={logo_cms} 
                            alt='logo' 
                        />
						<img 
                            className={cn("h-8 object-contain transition-all", isShowSideBar ? "block" : "hidden")} 
                            src={logo_cms_small} 
                            alt='logo-small' 
                        />
					</NavLink>
					
                    <button
                        type='button'
						className='inline-flex items-center justify-center rounded-xl p-2 text-muted-foreground hover:bg-muted hover:text-foreground lg:hidden'
                        onClick={() => setShowSidebarMobile()}
                    >
                        {isShowSideBarMobile ? <ChevronLeft className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
                    </button>
                    <button
                        type='button'
						className='hidden items-center justify-center rounded-xl p-2 text-muted-foreground hover:bg-muted hover:text-foreground lg:inline-flex'
                        onClick={() => showSideBar()}
                    >
                        {isShowSideBar ? <ChevronRight className="h-5 w-5" /> : <ChevronLeft className="h-5 w-5" />}
                    </button>
				</div>
                
                <ScrollArea className={cn('flex-1 py-4', isShowSideBar ? 'px-1' : 'px-0')}>
					{!isShowSideBar ? <MenuRender /> : <MenuRenderCollapsed />}
				</ScrollArea>

                {/* Keep sidebar footer clean in production */}
			</aside>
		</>
	);
};

export default Sidebar;
